import React from 'react'
import WindowPattern from './patterns/PatternSelector'

/**
 * 3 Part Slider Window Diagram
 * Three side-by-side panels
 */
const ThreePartSliderDiagram = ({
  selectedValue,
  availableOptions,
  onChange,
  mode,
  disabled,
  formData,
  allAvailableOptions
}) => {
  const fullWindowOption = availableOptions?.find(opt =>
    !opt.name.toLowerCase().includes('sash') &&
    !opt.name.toLowerCase().includes('lite')
  ) || availableOptions?.[0]

  const isSelected = selectedValue === fullWindowOption?.id

  const handleClick = () => {
    if (disabled || mode === 'display') return
    onChange(isSelected ? null : fullWindowOption?.id)
  }

  // Get grid style name for pattern
  const selectedGridStyle = allAvailableOptions?.grid_styles?.find(
    style => style.id === formData?.grid_style_id
  )

  // Get panel ratio to determine widths
  const selectedPanelRatio = formData?.panel_ratio_id
    ? allAvailableOptions?.panel_ratios?.find(ratio => ratio.id === formData.panel_ratio_id)
    : allAvailableOptions?.panel_ratios?.[0]

  // Determine panel widths based on ratio
  const isEqualThirds = selectedPanelRatio?.name?.includes('1/3')
  const endPanelWidth = isEqualThirds ? 112 : 84
  const middlePanelWidth = isEqualThirds ? 112 : 168

  return (
    <div className="flex justify-center items-center">
      <div
        className={`
          relative h-60 bg-light border-8 border-r-0 border-brand
          ${disabled ? 'opacity-50' : ''}
        `}
        style={{ width: endPanelWidth }}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={isSelected}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
      <div
        className={`
          relative h-60 bg-light border-8 border-r-0 border-brand
          ${disabled ? 'opacity-50' : ''}
        `}
        style={{ width: middlePanelWidth }}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={isSelected}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
      <div
        className={`
          relative h-60 bg-light border-8 border-brand
          ${disabled ? 'opacity-50' : ''}
        `}
        style={{ width: endPanelWidth }}
        onClick={handleClick}
      >
        <WindowPattern
          mode={mode}
          isSelected={isSelected}
          gridStyleName={selectedGridStyle?.name}
        />
      </div>
    </div>
  )
}

export default ThreePartSliderDiagram
